<template>
  <div>
    <WizardDetailWrapper
      :title="
        item.parentTitle ? `${item.parentTitle}: ${item.title}` : item.title
      "
      :is-bg-text="true"
      :is-past="isPastStatus()"
      :show-accordion="initialService.showAccordion"
      :name-input="item.name"
      :page-active="idPage.servicesPage"
      :validation="v$.name"
      :data="{
        item: item,
        index: item.indexUpdate,
        currentIndex: currentIndex,
        groupIndex: groupIndex,
      }"
      :is-api-error="
        (item?.id || !isChangePageClone) &&
        (isChangePageClone && item?.id
          ? { ...statusInPageClone, name: null }
          : statusInPageClone)
      "
      @update:accordion="
        initialService.showAccordion = !initialService.showAccordion
      "
      @update:save:change="processWhenDataValid"
      @update:input:name="
        // eslint-disable-next-line vue/brace-style
        {
          item.name = $event;
          handleSectionsChange('name');
        }
      "
    >
      <template #title>
        <input
          class="enter__name"
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-domain-placeholder-input-1',
            )
          "
          style="border: unset; background-color: unset"
          @click.stop
        />
      </template>
      <div
        :class="[
          'tw-flex tw-flex-col tw-gap-[20px]',
          showMoreDetail ? 'tw-rounded-b-none tw-pb-[25px]' : '',
        ]"
      >
        <WizardDropdownQuestion
          :index="index"
          :title="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-services-question-2',
            )
          "
          :current-type="item.initServiceType"
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-sites-prompt-1',
            )
          "
          :dropdown-data="item.serviceTypeOptions"
          :is-api-error="
            statusInPageClone?.serviceTypeId &&
            item?.serviceTypeId === statusInPageClone?.serviceTypeId
          "
          :required="true"
          :validation="v$.initServiceType"
          @update:model-value="
            (value: any) => {
              item.initServiceType = value;
              item.serviceTypeId = value.id;
              handleSectionsChange();
            }
          "
        />
        <MoreDetails
          :classes-more-detail="'!tw-p-0'"
          :is-show-questions="false"
          :is-details="isShowDetails(item) || isValidForm"
          @update:model-value="initialService.showQuestion = $event"
        />
      </div>
      <div
        :class="[
          'more-detail-container tw-flex tw-flex-col tw-gap-[20px]',
          initialService.showQuestion ? 'show' : '',
        ]"
      >
        <WizardDropdownQuestion
          v-if="initServiceComponentType"
          :index="index"
          :title="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-services-application-type-question-1',
            )
          "
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-sites-prompt-2',
            )
          "
          :dropdown-data="
            convertDataDropdown(
              WIZARD_STATE_QUESTION_TYPE_ID.SERVICE_COMPONENT_TYPE,
            )
          "
          :is-api-error="
            statusInPageClone?.orgServices?.[0]?.serviceComponentTypeId &&
            item?.orgServices?.[0]?.serviceComponentTypeId ===
              statusInPageClone?.orgServices?.[0]?.serviceComponentTypeId
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          :required="false"
          :current-type="initServiceComponentType"
          @update:model-value="
            (value) => {
              if (!item.orgServices || !item.orgServices.length) {
                item.orgServices = [{}];
              }
              item.orgServices[indexOrgServices ?? 0].serviceComponentTypeId =
                value.id;

              handleSectionsChange();
            }
          "
        />
        <WizardInputQuestion
          :type="INPUT_TYPE.Date"
          :title="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-services-start-date-question-1',
            )
          "
          :required="false"
          :validation="v$.startDate"
          :is-api-error="
            statusInPageClone?.startDate &&
            item.startDate === statusInPageClone?.startDate
          "
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-start-date-title',
            )
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          :model-value="item.startDate"
          @update:model-value="
            (value) => {
              item.startDate = dayjs(value).format('YYYY-MM-DD');
              v$.startDate.$validate();
              handleSectionsChange();
            }
          "
        />

        <WizardInputQuestion
          :type="INPUT_TYPE.Date"
          :title="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-services-end-date-question-1',
            )
          "
          :required="false"
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-start-date-title',
            )
          "
          :is-api-error="
            statusInPageClone?.endDate &&
            item.endDate === statusInPageClone?.endDate
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          :model-value="item.endDate"
          @update:model-value="
            (value) => {
              item.endDate = dayjs(value).format('YYYY-MM-DD');
              handleSectionsChange();
            }
          "
        >
          <div
            v-if="isPastStatus()"
            class="tw-mt-[10px] tw-flex tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
          >
            <div class="tw-flex tw-items-center tw-mr-[10px]">
              <img
                class="tw-w[17px tw-h-[17px]"
                src="@/assets/img/warning-orange-icon.svg"
              />
            </div>
            <span>{{
              getComponentUiText("app-settings-service-warning-past-1")
            }}</span>
          </div>
        </WizardInputQuestion>

        <WizardInputQuestion
          :type="INPUT_TYPE.TextArea"
          :title="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-services-description-question-1',
            )
          "
          :required="false"
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-description-title-1',
            )
          "
          :is-api-error="
            statusInPageClone?.description &&
            item.description === statusInPageClone?.description
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          :model-value="item.description"
          @update:model-value="
            (value) => {
              item.description = value;
              handleSectionsChange();
            }
          "
        />

        <WizardInputQuestion
          :type="INPUT_TYPE.TextArea"
          :title="
            getComponentUiText(
              'app-component-assessments-override-question-note-title-1',
            )
          "
          :required="false"
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-notes-title-1',
            )
          "
          :is-api-error="
            statusInPageClone?.notes && item.notes === statusInPageClone?.notes
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          :model-value="item.notes"
          @update:model-value="
            (value) => {
              item.notes = value;
              handleSectionsChange();
            }
          "
        />

        <WizardDropdownQuestion
          v-if="initServiceModelType"
          :index="index"
          :title="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-modal-services-modal-type-question-1',
            )
          "
          :placeholder="
            getComponentUiText(
              'app-menu-submenu-home-setup-wizard-service-mode-type-title-1',
            )
          "
          :is-api-error="
            statusInPageClone?.orgServices?.[0]?.serviceModelType &&
            item?.orgServices?.[0]?.serviceModelType ===
              statusInPageClone?.orgServices?.[0]?.serviceModelType
          "
          :dropdown-data="
            convertDataDropdown(
              WIZARD_STATE_QUESTION_TYPE_ID.SERVICE_MODEL_TYPE,
            )
          "
          :class-title="'tw-text-[14px] !tw-leading-[100%]'"
          :required="false"
          :current-type="initServiceModelType"
          @update:model-value="
            (value) => {
              if (!item.orgServices || !item.orgServices.length) {
                item.orgServices = [{}];
              }
              item.orgServices[indexOrgServices ?? 0].serviceModelType =
                value.id;

              handleSectionsChange();
            }
          "
        />
      </div>
    </WizardDetailWrapper>
  </div>
</template>
<script setup lang="ts">
import {
  IsPhoneNumber,
  getComponentUiText,
  removeNullProperties,
} from "@/utils/utilities";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import WizardDropdownQuestion from "./wizardDropdownQuestion.vue";
import MoreDetails from "./moreDetails.vue";
import { PropType, Ref, computed, onMounted, reactive, ref, watch } from "vue";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import {
  INPUT_TYPE,
  WIZARD_STATE_PAGE,
  WIZARD_STATE_QUESTION_TYPE_ID,
  idWizardPage as idPage,
  statusPage,
} from "@/utils/constants";

import {
  IWizardQuestion,
  IWizardServicesValue,
  IWizardTypeValue,
} from "@/interfaces/wizard";
import { required, helpers, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import store from "@/store";
import cloneDeep from "lodash/cloneDeep";
import dayjs from "dayjs";

const props = defineProps({
  itemFirst: {
    type: Object as PropType<IWizardServicesValue>,
    required: true,
  },
  currentIndex: {
    type: Number,
    required: true,
  },
  groupIndex: {
    type: Number,
    required: true,
  },
  questionSectionValue: {
    type: Object as PropType<IWizardQuestion[]>,
    required: true,
  },
  currentOrg: {
    type: Number,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});

const isCallAPI = ref(false);

const saveChanges = async () => {
  isChangePageClone.value = false;
  await v$.value.$validate();
  if (!initialService.value.showMoreDetails) {
    v$.value.orgServicesName.$reset();
  }
  const isValid = !v$.value.$errors || v$.value.$errors.length === 0;
  if (!isValid) {
    const errors = v$.value.$errors;
    errors.forEach((item) => {
      if (item.$property === "initServiceType") {
        initialService.value.showAccordion = true;
      }
      if (item.$property === "startDate") {
        initialService.value.showAccordion = true;
        isValidForm.value = "1";
      }
      if (
        item.$property === "orgServicesName" ||
        item.$property === "orgServicesProviderEmailCommerical" ||
        item.$property === "orgServicesProviderEmailSupport" ||
        item.$property === "orgServicesProviderPhone"
      ) {
        initialService.value.showAccordion = true;
        initialService.value.question = true;
        isValidForm.value = "1";
        initialService.value.showMoreDetails = true;
      }
    });
  } else {
    processWhenDataValid(true);
  }
  if (isValid) {
    isCallAPI.value = true;
  }
  return { isValid };
};

const processWhenDataValid = (isCloseInput = false) => {
  let finalValue;
  const cacheItem = { ...item.value };
  if (isCloseInput) {
    initialService.value.showAccordion = false;
    initialService.value.showMoreDetails = false;
  }
  let finalOrgService = {} as any;
  if (
    cacheItem.orgServices &&
    cacheItem.orgServices[indexOrgServices.value ?? 0]
  ) {
    finalOrgService = cacheItem.orgServices[indexOrgServices.value ?? 0];
  }
  finalOrgService.name = cacheItem.orgServicesName; //
  finalOrgService.description = cacheItem.orgServicesDescription;
  finalOrgService.serviceComponentTypeId =
    cacheItem.orgServices?.[indexOrgServices.value ?? 0]
      ?.serviceComponentTypeId || null;
  finalOrgService.serviceModelType =
    cacheItem.orgServices?.[indexOrgServices.value ?? 0]?.serviceModelType ||
    null;
  finalOrgService.startDate =
    cacheItem.orgServices?.[indexOrgServices.value ?? 0]?.startDate || null;
  removeNullProperties(finalOrgService);
  finalValue = {
    updated: true,
    description: cacheItem.description || "",
    endDate: cacheItem.endDate || null,
    id: cacheItem.id || null,
    isArchived: cacheItem.isArchived || false,
    name: cacheItem.name || null,
    notes: cacheItem.notes || "",
    orgServices: [finalOrgService],
    serviceTypeId: cacheItem.serviceTypeId,
    startDate: cacheItem.startDate || null,
  } as IWizardServicesValue;
  removeNullProperties(finalValue);
  if (isChangePage) {
    onUpdateValueInStore(finalValue, cacheItem.indexUpdate);
    isChangePage = false;
  } else if (!isCloseInput && item.value.id) {
    onUpdateFormatValueInStore(item);
    onUpdateValueInStore(finalValue, cacheItem.indexUpdate);
  }
};

const onUpdateFormatValueInStore = (value) => {
  store.commit("SetupWizard/SET_FORMAT_VALUES_SERVICE_UPDATE", {
    value,
    currentIndex: props.currentIndex,
    groupIndex: props.groupIndex,
    currentOrg: props.currentOrg,
  });
};

const onUpdateValueInStore = (value, indexUpdate?) => {
  if (indexUpdate !== undefined || item.value.idUpdate) {
    store.commit("SetupWizard/SET_VALUES_SERVICE_UPDATE", {
      value: { ...value, idUpdate: item.value.idUpdate },
      indexUpdate,
      currentOrg: props.currentOrg,
    });
  } else {
    store.commit("SetupWizard/SET_VALUES_SERVICE_UPDATE", {
      value,
      currentOrg: props.currentOrg,
    });
  }
};

const isValidForm: Ref<string> = ref("");

const initialService: Ref<any> = ref({
  showAccordion: false,
  showQuestion: false,
  showMoreDetails: false,
});

const handleSectionsChange = (field?: string) => {
  emits("update:service", cloneDeep(item.value));
  if (statusInPageClone.value && (!item.value.id || field === "name")) {
    isChangePageClone.value = true;
  }
  if (isChangePage) {
    return;
  }
  isChangePage = true;
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    currentOrg: props.currentOrg,
    isSelected: true,
    namePage: WIZARD_STATE_PAGE.SERVICES,
    isSelectedPage: "isSelectedServices",
  });
};

const emits = defineEmits(["update:service", "add:service"]);

const item = ref({ ...props.itemFirst });

const bodyAPIError = computed(() => {
  if (
    !item.value?.id &&
    props.statusInPage.dataError?.length > 0 &&
    isCallAPI.value
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError?.find((i) => i.id === item.value.id)
  );
});
const statusInPageClone = ref(bodyAPIError);
const isChangePageClone = ref(false);
let isChangePage = false;
const IsStartDateValid = (val) => {
  if (val && item.value.endDate) {
    return new Date(val) < new Date(item.value.endDate);
  }
  return true;
};

const isProviderNameRequired = (val) => {
  if (initialService.value.showMoreDetails) {
    return val ? true : false;
  }
  return true;
};

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  initServiceType: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  startDate: {
    specialChar: helpers.withMessage(
      () => getComponentUiText("app-setting-org-setup-invalid-start-date"),
      IsStartDateValid,
    ),
  },
  orgServicesName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      isProviderNameRequired,
    ),
  },
  orgServicesProviderEmailSupport: {
    specialChar: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-email-1"),
      email,
    ),
  },
  orgServicesProviderEmailCommerical: {
    specialChar: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-email-1"),
      email,
    ),
  },
  orgServicesProviderPhone: {
    phoneNumber: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      IsPhoneNumber,
    ),
  },
};
let v$ = useVuelidate(rules, item as any);
const showMoreDetail: Ref<boolean> = ref(false);
const initServiceComponentType: Ref<any> = ref(null);
const initServiceModelType: Ref<any> = ref(null);
const indexOrgServices: Ref<number> = ref(0);

onMounted(() => initial());

const initial = async () => {
  const componentTypes =
    props.questionSectionValue[0].types[2].typeValues ?? [];
  const modelTypes = props.questionSectionValue[0].types[3].typeValues ?? [];
  // for MVP: find index orgServices which has max id
  const orgServices = cloneDeep(item.value.orgServices || []);
  if (orgServices.length > 0) {
    if (orgServices.length === 1) {
      indexOrgServices.value = 0;
    } else {
      indexOrgServices.value = orgServices
        .map((orgService, index) => ({ ...orgService, index }))
        .filter((orgServiceMap) => !orgServiceMap.isArchived)
        .reduce(
          (max, orgServiceMap) => {
            return orgServiceMap.id > max.id ? orgServiceMap : max;
          },
          { id: -Infinity },
        ).index;
    }
  }
  initServiceComponentType.value =
    componentTypes.find(
      (x) =>
        x.id ===
        item.value.orgServices?.[indexOrgServices.value]
          ?.serviceComponentTypeId,
    ) || {};

  initServiceModelType.value =
    modelTypes.find(
      (x) =>
        x.id ===
        item.value.orgServices?.[indexOrgServices.value]?.serviceModelType,
    ) || {};
};

watch(
  () => props.itemFirst,
  (newValue) => {
    item.value = { ...newValue };
  },
  { immediate: true },
);

watch(
  () => item.value.orgServices?.[indexOrgServices.value]?.serviceModelType,
  () => {
    const modelTypes = props.questionSectionValue[0].types[3].typeValues ?? [];
    initServiceModelType.value =
      modelTypes.find(
        (x) =>
          x.id ===
          item.value.orgServices?.[indexOrgServices.value]?.serviceModelType,
      ) || {};
  },
  { immediate: true },
);

watch(
  () =>
    item.value.orgServices?.[indexOrgServices.value]?.serviceComponentTypeId,
  () => {
    const componentTypes =
      props.questionSectionValue[0].types[2].typeValues ?? [];
    initServiceComponentType.value =
      componentTypes.find(
        (x) =>
          x.id ===
          item.value.orgServices?.[indexOrgServices.value]
            ?.serviceComponentTypeId,
      ) || {};
  },
  { immediate: true },
);

const isPastStatus = () => {
  return item.value.endDate
    ? dayjs(item.value.endDate).isBefore(dayjs(), "day")
    : false;
};

const convertDataDropdown = (typeId) => {
  let data: IWizardTypeValue[] = [];

  if (props.questionSectionValue) {
    props.questionSectionValue[0].types.forEach((item) => {
      if (item.typeId === typeId && !data.length) {
        data = item.typeValues;
      }
    });
  }
  const dataDropdown = data.map((item: IWizardTypeValue) => {
    return {
      name: item.name ?? "",
      value: item.order ?? "",
      id: item.id ?? "",
    };
  });

  return dataDropdown;
};

const isShowDetails = (item) => {
  if (
    item?.componentType?.id ||
    item?.modelType?.id ||
    item?.startDate ||
    item?.endDate ||
    item?.description ||
    item?.notes ||
    item?.modelType?.id
  ) {
    return "1";
  } else {
    return "";
  }
};
defineExpose({
  saveChanges,
});
</script>

<style lang="scss" scoped>
.question {
  position: relative;
}
.question::after {
  content: "*";
  position: relative;
  right: -4px;
  top: -2px;
  color: #f7553c;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
.right-arrow-icon {
  margin-left: 10px;
  transition: transform 0.3s ease;
  transform: rotate(90deg) scale(1.2);

  &.show {
    transform: rotate(-90deg) scale(1.2);
  }
}

.more-detail-container {
  margin: 0;
  padding: 0;
  height: 0px;
  overflow: hidden;
  transition:
    height 0.3s ease,
    padding 0.3s ease;

  &.show {
    border-top: 1px solid #eff0f1;
    margin: 0px -25px -25px -25px;
    padding: 25px;
    height: auto;
    overflow: visible;
  }
}
.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  width: 98%;
}
::-ms-input-placeholder {
  color: red;
}
@media screen and (max-width: 590px) {
  .enter__name {
    width: 100%;
  }
}

.is-invalid {
  display: block !important;
  color: #f7553c;
}
</style>
